/**
 * Created by mqamhieh on 6/14/18.
 */
(function() {

    "use strict";

    angular.module("userActivation", []);
})();